export enum AccountRequestState {
  Pending = 'pending',
  Used = 'used',
  Deleted = 'deleted',
  Expired = 'expired',
}
